import TwitterIcon from '@bufferapp/ui/Icon/Icons/Twitter';
import FacebookIcon from '@bufferapp/ui/Icon/Icons/Facebook';
import LinkedinIcon from '@bufferapp/ui/Icon/Icons/LinkedIn';
import InstagramIcon from '@bufferapp/ui/Icon/Icons/Instagram';
import TiktokIcon from '@bufferapp/ui/Icon/Icons/Tiktok';
import PinterestIcon from '@bufferapp/ui/Icon/Icons/Pinterest';
import GbpIcon from '@bufferapp/ui/Icon/Icons/Gbp';
import React from 'react';

export const ChannelIcon = (channelName) => {
  switch (channelName) {
    case 'twitter':
      return <TwitterIcon />;
      break;
    case 'facebook':
      return <FacebookIcon />;
      break;
    case 'linkedin':
      return <LinkedinIcon />;
      break;
    case 'instagram':
      return <InstagramIcon />;
      break;
    case 'tiktok':
      return <TiktokIcon />;
      break;
    case 'pinterest':
      return <PinterestIcon />;
      break;
    case 'googlebusiness':
      return <GbpIcon />;
      break;
    default:
      return <></>;
  }
};
